export const supplementalFormRouteMap = new Map<string, string[]>([
  ['AfterServiceSupplemental', ['endPermit']],
  ['AfterInductionSupplemental', ['inductionForm']],
  // ['AfterWorkOrderSupplemental', ['workOrder']], // route not created
  // ['AfterNoticeSupplemental', ['notice']], // route not created
])
